var React = require('react');

function Pray (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 128a64 64 0 1 1 64-64 64 64 0 0 1-64 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M201.22 269l-34.8 64.87 109.86 109.85C301.77 469.21 282.08 512 248 512H40a40 40 0 0 1 0-80h91.56l-44.81-34.89C43.87 369.73 29.16 317 52.56 273.36l49.37-92c11.12-20.65 32.18-34.44 56.37-36.92 24.78-2.59 48.56 6.94 64 25.33l38.91 46.31 57.44-47A40 40 0 1 1 369.34 231l-88 72a40 40 0 0 1-56-5.22z","className":"fa-primary","key":2})]);
}

Pray.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = Pray;

Pray.default = Pray;
